import React from 'react';
import { Crown, CheckCircle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function PremiumUpsellModal({
  open,
  onClose,
  title = "Ya utilizaste tu postulación gratuita",
  description = "Este mes ya recibiste oportunidades reales. Hazte Premium para seguir postulando."
}) {

  const navigate = useNavigate();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">

      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg relative overflow-hidden">

        <button
          onClick={onClose}
          className="absolute top-5 right-5 text-gray-400 hover:text-gray-700"
        >
          <X className="w-5 h-5"/>
        </button>

        <div className="bg-gradient-to-r from-[#E6202E] to-red-500 p-8 text-white text-center">

          <Crown className="w-14 h-14 mx-auto mb-4"/>

          <h2 className="text-3xl font-bold">
            {title}
          </h2>

          <p className="mt-3 opacity-95">
            {description}
          </p>

        </div>

        <div className="p-8">

          <div className="space-y-4">

            {[
              "Postulaciones ilimitadas",
              "Correos automáticos",
              "Mensaje personalizado",
              "Prioridad en resultados",
              "Más posibilidades de conseguir clientes"
            ].map(item => (

              <div key={item} className="flex gap-3 items-center">

                <CheckCircle className="text-green-600 w-5 h-5"/>

                <span>{item}</span>

              </div>

            ))}

          </div>

          <div className="mt-8 flex gap-3">

            <Button
              className="flex-1 bg-[#E6202E] hover:bg-[#D31522]"
              onClick={() => navigate('/provider/subscription')}
            >
              Activar Premium
            </Button>

            <Button
              variant="outline"
              className="flex-1"
              onClick={onClose}
            >
              Más tarde
            </Button>

          </div>

        </div>

      </div>

    </div>
  );

}
